import { render, staticRenderFns } from "./premiumMain.vue?vue&type=template&id=6bf9f795&scoped=true"
import script from "./premiumMain.vue?vue&type=script&lang=js"
export * from "./premiumMain.vue?vue&type=script&lang=js"
import style0 from "./premiumMain.vue?vue&type=style&index=0&id=6bf9f795&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf9f795",
  null
  
)

export default component.exports